export const ImportFrequencyEnum = {
  Every24Hours: 0,
  Every12Hours: 1,
  Every6Hours: 2,
  Every3Hours: 3,
  Every2Hours: 4,
  EveryHour: 5,
};

export const studentNotFoundMessage = 'Student Not Found';
export const SuccessNotificationTitle = 'Aeries Import Complete';
export const FailedNotificationTitle = 'Aeries Import Failed';



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/helpers/Constants.js